import Region from "../Region";
import RegionArea from "../RegionArea";
import Phaser from 'phaser';

import * as ABCya from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import { AREAS, REGIONS, SHAPES } from '../gameData';

export default class PeachBuildingArea extends RegionArea
{
    /**
     * Create the peach building area.
     * @param {Region} region the owner region
     */
    constructor(parentRegion)
    {
        super(parentRegion, AREAS[REGIONS.DOWNTOWN].PEACH_BUILDING);

        this._createArea();

        this.reset();
    }

    /**
     * Reset should be called when you want to set the state to a disabled/inactive state.
     */
    reset()
    {
        super.reset();

        this.window0.setAlpha(0);
        this.window1.setAlpha(0);
        this.wall.setAlpha(0);
        this.door.setAlpha(0);
        this.chairBack0.setAlpha(0);
        this.chairBack1.setAlpha(0);
        this.chair0.setAlpha(0);
        this.chair1.setAlpha(0);
    }

    /**
     * Prepare should be called before you want to prepare the state to become active.
     */
    prepare()
    {
        super.prepare();

        this.window0.disableInteractive();
        this.window1.disableInteractive();
        this.wall.disableInteractive();
        this.door.disableInteractive();
        this.chairBack0.disableInteractive();
        this.chairBack1.disableInteractive();
        this.chair0.disableInteractive();
        this.chair1.disableInteractive();
    }

    /**
     * Send all game objects to their start positions.
     */
    _sendObjectsToStartPositions()
    {
        super._sendObjectsToStartPositions();

        this.window0.setAlpha(0.000001);
        this.window1.setAlpha(0.000001);
        this.wall.setAlpha(0.000001);
        this.door.setAlpha(0.000001);
        this.chairBack0.setAlpha(0.000001);
        this.chairBack1.setAlpha(0.000001);
        this.chair0.setAlpha(0.000001);
        this.chair1.setAlpha(0.000001);
    }

    /**
     * Creates the area, by adding the overlays to the parent region and creates the area information sidebar.
     */
    _createArea()
    {
        let windowHitArea = new Phaser.Geom.Polygon(
            [
                { x: 85, y: 101 },
                { x: 70, y: 107 },
                { x: 32, y: 89 },
                { x: 4, y: 45 },
                { x: 9, y: 6 },
                { x: 44, y: 6 },
                { x: 74, y: 30 },
                { x: 93, y: 67 },
            ]);
        this.window0 = ABCya.Images.addImage(396, 364, UIAssetKeys._08_Downtown_Zoom_In_Peach_Building_Slct_Wndw, this.parentRegion).setInteractive(windowHitArea, Phaser.Geom.Polygon.Contains);
        this.window0.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.window0, SHAPES.CIRCLE);
        });

        this.window1 = ABCya.Images.addImage(699, 539, UIAssetKeys._08_Downtown_Zoom_In_Peach_Building_Slct_Wndw, this.parentRegion).setInteractive(windowHitArea, Phaser.Geom.Polygon.Contains);
        this.window1.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.window1, SHAPES.CIRCLE);
        });


        let wallHitArea = new Phaser.Geom.Polygon(
            [
                { x: 214, y: 228 },
                { x: 0, y: 351 },
                { x: 0, y: 121 },
                { x: 214, y: 0 },
            ]);
        this.wall = ABCya.Images.addImage(868, 517, UIAssetKeys._08_Downtown_Zoom_In_Peach_Building_Slct_Wall, this.parentRegion).setInteractive(wallHitArea, Phaser.Geom.Polygon.Contains);
        this.wall.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.wall, SHAPES.SQUARE);
        });

        let doorHitArea = new Phaser.Geom.Polygon(
            [
                { x: 123, y: 191 },
                { x: 0, y: 122 },
                { x: 0, y: 0 },
                { x: 123, y: 69 },
            ]);
        this.door = ABCya.Images.addImage(565, 491, UIAssetKeys._08_Downtown_Zoom_In_Peach_Building_Slct_Drs, this.parentRegion).setInteractive(doorHitArea, Phaser.Geom.Polygon.Contains);
        this.door.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.door, SHAPES.SQUARE);
        });

        let chairBackHitArea = new Phaser.Geom.Polygon(
            [
                { x: 46, y: 78 },
                { x: 0, y: 51 },
                { x: 19, y: 0 },
                { x: 65, y: 28 },
            ]);
        this.chairBack0 = ABCya.Images.addImage(645, 195, UIAssetKeys._08_Downtown_Zoom_In_Peach_Building_Slct_ChrBk, this.parentRegion).setInteractive(chairBackHitArea, Phaser.Geom.Polygon.Contains);
        this.chairBack0.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.chairBack0, SHAPES.SQUARE);
        });

        this.chairBack1 = ABCya.Images.addImage(720, 237, UIAssetKeys._08_Downtown_Zoom_In_Peach_Building_Slct_ChrBk, this.parentRegion).setInteractive(chairBackHitArea, Phaser.Geom.Polygon.Contains);
        this.chairBack1.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.chairBack1, SHAPES.SQUARE);
        });

        let chairSeatHitArea = new Phaser.Geom.Polygon(
            [
                { x: 46, y: 56 },
                { x: 0, y: 28 },
                { x: 46, y: 0 },
                { x: 92, y: 28 },
            ]);
        this.chair0 = ABCya.Images.addImage(616, 231, UIAssetKeys._08_Downtown_Zoom_In_Peach_Building_Slct_ChrSt, this.parentRegion).setInteractive(chairSeatHitArea, Phaser.Geom.Polygon.Contains);
        this.chair0.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.chair0, SHAPES.SQUARE);
        });

        this.chair1 = ABCya.Images.addImage(690, 274, UIAssetKeys._08_Downtown_Zoom_In_Peach_Building_Slct_ChrSt, this.parentRegion).setInteractive(chairSeatHitArea, Phaser.Geom.Polygon.Contains);
        this.chair1.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.chair1, SHAPES.SQUARE);
        });

        this.shapeOverlays[SHAPES.SQUARE] = [this.wall, this.door, this.chair0, this.chair1, this.chairBack0, this.chairBack1];
        this.shapeOverlays[SHAPES.CIRCLE] = [this.window0, this.window1];

        this._createAreaInformation(0x5f5fd6, 0x2b4270);
    }

    /**
     * Zoom into the area.
     */
    zoomIn()
    {
        let tweens = super.zoomIn();

        tweens.push(
            {
                targets: [
                    this.parentRegion.blueBuilding, this.parentRegion.greenBuilding, this.parentRegion.treeAndBenchContainer
                ],
                duration: 500,
                props: { alpha: 0 },
                ease: Phaser.Math.Easing.Quadratic.Out,
            },
            { targets: this.parentRegion.peachBuilding, duration: 1000, props: { scale: 1, x: 649, y: 390 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 0 },
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.onScreenPosition.x }, ease: Phaser.Math.Easing.Back.Out, offset: 500 }
        );

        return tweens;
    }

    /**
     * Zoom out of the area.
     */
    zoomOut()
    {
        let tweens = super.zoomOut();

        this.window0.disableInteractive();
        this.window1.disableInteractive();
        this.wall.disableInteractive();
        this.door.disableInteractive();
        this.chairBack0.disableInteractive();
        this.chairBack1.disableInteractive();
        this.chair0.disableInteractive();
        this.chair1.disableInteractive();

        for (let shape in this.shapeOverlays)
        {
            // fade off the overlay
            tweens.push(
                {
                    targets: this.shapeOverlays[shape],
                    duration: 500,
                    props: { alpha: 0 },
                    ease: Phaser.Math.Easing.Quadratic.Out,
                    offset: 0
                }
            );
        }

        tweens.push(
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.offScreenPosition.x }, ease: Phaser.Math.Easing.Back.In, offset: 0 },
            { targets: this.parentRegion.peachBuilding, duration: 1000, props: { scale: 0.625, x: this.parentRegion.peachBuilding.onScreenPosition.x, y: this.parentRegion.peachBuilding.onScreenPosition.y }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 250 },
            { targets: [this.parentRegion.blueBuilding, this.parentRegion.greenBuilding, this.parentRegion.treeAndBenchContainer], duration: 500, props: { alpha: 1 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 500 },
        );

        return tweens;
    }
}